import i18next from 'i18next';
import { capitalize } from 'utils';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import { Image } from 'antd';
import {
  digitalEngagementTypes,
  type DigitalEngagementType,
} from 'infrastructure/data-sources/digital-engagement';

import s from './styles.module.scss';

import type { IBaseTableColumns } from 'components/atoms/base-table/types';
import type { ISmsActivity } from 'infrastructure/interfaces';

export const columns = (): IBaseTableColumns<ISmsActivity> => {
  return [
    {
      label: i18next.t('labels.dateTime'),
      key: 'createdAt',
      width: '120px',
      render(value) {
        return (
          <span data-cy="sms-date">
            {DateFormatter({
              date: value,
              format: DateFormats['MM-dd-yyyy h:mm a'],
            })}
          </span>
        );
      },
    },
    {
      label: i18next.t('labels.smsTextElectronicallySignedBy'),
      key: 'message',
      width: '500px',
      responsive: ['md'],
      render(value, record) {
        return (
          <>
            {record.mediaUrl && (
              <span className={s.media}>
                <Image width={20} src={record.mediaUrl} />
              </span>
            )}
            <span data-cy="sms-message">{value}</span>
          </>
        );
      },
    },
    {
      label: i18next.t('labels.from'),
      key: 'from',
      width: '200px',
      render(value: any) {
        return <span data-cy="sms-from">{value}</span>;
      },
    },
    {
      label: i18next.t('labels.to'),
      key: 'to',
      width: '200px',
      render(value: any) {
        return <span data-cy="sms-to">{value}</span>;
      },
    },
    {
      label: i18next.t('labels.author'),
      key: 'createdBy',
      width: '140px',
      render(value: string) {
        return (
          <span data-cy="sms-author">
            {value === 'Accuhealth' ? 'Unknown (Outside of Evelyn)' : value}
          </span>
        );
      },
    },
    {
      label: i18next.t('labels.status'),
      key: 'status',
      width: '140px',
      render(value: string) {
        return <span data-cy="sms-status">{capitalize(value)}</span>;
      },
    },
    {
      label: i18next.t('digitalEngagement.digitalEngagement'),
      key: 'digitalEngagement',
      width: '140px',
      render(value: DigitalEngagementType) {
        return (
          <span data-cy="sms-status">{digitalEngagementTypes[value]}</span>
        );
      },
    },
  ];
};
